import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function SearchMetaData(
  searchedText: string,
): PageMetaDataValues {
  const sectionName = "miscellaneous";
  const metaTitle = `Search For "${searchedText}" - Beritaharian`;

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    slug: `search/site/${searchedText}`,
  };

  const gaData: GADataProps = {
    level2: sectionName,
    section: sectionName,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
